  import React, { useState } from "react";
  import { faDownload, faPhone } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { Nav, Navbar } from "react-bootstrap";
  import { useNavigate, useLocation } from "react-router-dom";

  import InquiryFormModal from "../common_components/InquiryFormModal/InquiryFormModal";
  import "./Header.css";

  function Header() {
    const navigate = useNavigate();
    const location = useLocation();

    const [expanded, setExpanded] = useState(false);
    const [modalshow, setmodalshow] = useState(false);

    const handleNavClick = (path) => {
      navigate(path);
      setExpanded(false);
    };

    return (
      <section className="main_head">
        {/* Top Buttons */}
        <div className="inquirybtndiv">
          <a href="tel:+919607755557" className="inquirybtn">
            <span>
              <FontAwesomeIcon icon={faPhone} style={{ color: "#fff" }} />
            </span>
            CALL US
          </a>

          <button
            className="inquirybtn"
            onClick={() => setmodalshow(true)}
          >
            <span>
              <FontAwesomeIcon icon={faDownload} style={{ color: "#fff" }} />
            </span>
            DOWNLOAD BROCHURE
          </button>
        </div>

        <div className="container-md">
          <Navbar
            expand="md"
            className="main_navbar p-0"
            onToggle={(value) => setExpanded(value)}
            expanded={expanded}
          >
            {/* Logo */}
            <Navbar.Brand>
              <div
                className="logodiv"
                onClick={() => handleNavClick("/")}
              >
                <img
                  src="/assets/images/header/logo.png"
                  alt="Logo"
                  className="logo_img"
                />
              </div>
            </Navbar.Brand>

            {/* Mobile Right Section */}
            <div className="mobile_logo_holder_2">
              <img
                src="/assets/images/header/right-head-logo.png"
                alt="Logo"
                className="logo_img new_logo"
              />

              <div className="number_class">
                <span>
                  <FontAwesomeIcon icon={faPhone} style={{ color: "#fff" }} />
                </span>
                <a href="tel:+919607755557">+91 9607755557</a>
              </div>
            </div>

            <Navbar.Toggle />

            <Navbar.Collapse>
              <div className="links_holder">
                <div className="links_div">
                  <Nav className="nav_links">
                    <Nav.Link
                      onClick={() => handleNavClick("/")}
                      className={location.pathname === "/" ? "active" : ""}
                    >
                      Home
                    </Nav.Link>

                    <Nav.Link
                      onClick={() => setmodalshow(true)}
                      className={location.pathname === "/programs" ? "active" : ""}
                    >
                      Programs
                    </Nav.Link>

                    <Nav.Link
                      onClick={() => setmodalshow(true)}
                      className={location.pathname === "/admissions" ? "active" : ""}
                    >
                      Admissions
                    </Nav.Link>

                    <Nav.Link
                      onClick={() => setmodalshow(true)}
                      className={location.pathname === "/contact-us" ? "active" : ""}
                    >
                      Contact Us
                    </Nav.Link>
                  </Nav>
                </div>
              </div>

              {/* Desktop Right Section */}
              <div className="desk_logo_holder_2">
                <img
                  src="/assets/images/header/right-head-logo.png"
                  alt="Logo"
                  className="logo_img"
                />

                <div className="number_class">
                  <span>
                    <FontAwesomeIcon icon={faPhone} style={{ color: "#fff" }} />
                  </span>
                  <a href="tel:+919607755557">+91 9607755557</a>
                </div>
              </div>
            </Navbar.Collapse>
          </Navbar>
        </div>

        {/* Modal */}
        <InquiryFormModal
          show={modalshow}
          onHide={() => setmodalshow(false)}
          setmodalshow={setmodalshow}
          modalshow={modalshow}
        />
      </section>
    );
  }

  export default Header;